/**
 * SA-946: what the Inbox does per channel, in one place — the icon a channel
 * wears, whether a thread on it carries triage, whether it is a WhatsApp
 * group, and whether it shows the record sidebar. The list row and the
 * detail header read the icon from here.
 */
import { Globe, Mail, Phone, Users, type LucideIcon } from 'lucide-react'

/** A Map, never an object: `'toString' in {}` is true. */
const ICONS = new Map<string, LucideIcon>([
  ['whatsapp', Phone], ['web', Globe], ['email', Mail], ['whatsapp-group', Users],
])

/** A channel's icon; an unknown channel reads as web. */
export function channelIcon(channel: string | null | undefined): LucideIcon {
  return (channel ? ICONS.get(channel) : undefined) ?? Globe
}

/** The backend's `email_ingestion.TRIAGED_CHANNELS`. */
const TRIAGED = new Set(['email', 'whatsapp-group'])

export function isTriagedChannel(channel: string | null | undefined): boolean {
  return TRIAGED.has(channel ?? '')
}

export function isGroupChannel(channel: string | null | undefined): boolean {
  return channel === 'whatsapp-group'
}

/** The record sidebar: on a WhatsApp or email thread, or any thread with a
 * record — never on a WhatsApp group, whose records are per message (SA-946
 * G1); each of its triage rows links its own. */
export function showsRecordSidebar(conversation: { channel: string; linkedOrderId: string | null }): boolean {
  if (isGroupChannel(conversation.channel)) return false
  return conversation.channel === 'whatsapp' || conversation.channel === 'email' || !!conversation.linkedOrderId
}
